import Vue from "vue";
import store from "./store/store";
import App from "./App.vue";
import Axios from "axios";
import vuetify from "./plugins/vuetify";
import router from "./router";
export const bus = new Vue();

Vue.config.productionTip = true;
Axios.defaults.withCredentials = true;

// Axios.defaults.baseURL = "http://localhost:8080";

new Vue({
  store,
  vuetify,
  bus,
  router,
  render: (h) => h(App),
}).$mount("#app");
